import React, { useEffect, useState } from 'react';
import ManagerSidebar from '../components/Sidebar/ManagerSidebar';
import { FaUser, FaEnvelope, FaRegCommentDots, FaCalendarAlt, FaSearch, FaTimes } from 'react-icons/fa';
import './ContactMessagesList.css'; 

const ContactMessagesList = () => {
  const [messages, setMessages] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const res = await fetch('https://ikaze-thouse-backend.vercel.app/api/v1/contact/getMessages');
        const data = await res.json();

        if (res.ok && data.success) {
          setMessages(data.data);
        } else {
          setError(data.message || 'Failed to fetch messages');
        }
      } catch (err) {
        setError('Server error. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  // Filter messages dynamically based on user query input
  const filteredMessages = messages.filter((msg) => {
    const query = searchQuery.toLowerCase().trim();
    if (!query) return true; // If search is empty, show all messages

    return (
      msg.name?.toLowerCase().includes(query) ||
      msg.email?.toLowerCase().includes(query) ||
      msg.message?.toLowerCase().includes(query)
    );
  });

  return (
    <div className="messages-layout">
      <ManagerSidebar />

      <div className="messages-container">
        
        {/* Dashboard Header Control Layer */}
        <div className="dashboard-controls">
          <h2 className="messages-header">Contact Messages</h2>
          
          {!loading && !error && messages.length > 0 && (
            <div className="search-wrapper">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search by name, email, or keywords..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
              />
              {searchQuery && (
                <button 
                  className="clear-search-btn" 
                  onClick={() => setSearchQuery('')}
                  title="Clear search"
                >
                  <FaTimes />
                </button>
              )}
            </div>
          )}
        </div>

        {loading && <div className="state-message">Loading messages...</div>}
        {error && <div className="state-message error">{error}</div>}

        {!loading && !error && messages.length === 0 && (
          <div className="state-message">No messages found in your inbox.</div>
        )}

        {/* Handling Empty Search Results Case State */}
        {!loading && !error && messages.length > 0 && filteredMessages.length === 0 && (
          <div className="state-message info">
            No messages matches your search criteria: "<strong>{searchQuery}</strong>"
          </div>
        )}

        {/* Render filtered data stream */}
        {!loading && !error && filteredMessages.map(({ id, name, email, message, created_at }) => (
          <div key={id} className="message-card">
            
            <div className="meta-row">
              <div className="sender-profile">
                <span className="sender-name">
                  <FaUser className="meta-icon" /> {name}
                </span>
                <span className="sender-email">
                  <FaEnvelope className="meta-icon" /> {email}
                </span>
              </div>
              
              <div className="message-date">
                <FaCalendarAlt />
                <span>
                  {new Date(created_at).toLocaleDateString(undefined, { 
                    month: 'short', 
                    day: 'numeric', 
                    hour: '2-digit', 
                    minute: '2-digit' 
                  })}
                </span>
              </div>
            </div>

            <div className="message-body">
              <FaRegCommentDots className="meta-icon" style={{ marginTop: '4px' }} />
              <p className="message-text">{message}</p>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactMessagesList;